import React from 'react';
import { newsItems } from '../data/mockData';
import '../styles/News.css';

const News: React.FC = () => {
  return (
    <div className="news-container">
      <h1>Latest News & Updates</h1>
      <div className="news-list">
        {newsItems.map((item) => (
          <div key={item.id} className="news-item">
            <div className="news-header">
              <h2>{item.title}</h2>
              <span className="news-date">{item.date}</span>
            </div>
            <p className="news-content">{item.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default News;
